export var getPartLocale = function (fullLocale) {
    return fullLocale.slice(0, 2);
};
